import React from 'react';
import { Text } from 'core';
import { css, theme } from 'constants';
import { format, distanceInWordsToNow, isToday, isYesterday, getDay, subDays, isWithinRange } from 'date-fns';
import { lang } from 'lang';
import ar from 'date-fns/locale/ar';
import en from 'date-fns/locale/en';

const lang_list = { ar, en };
const styles = css({
  text: {
    fontSize: theme.font_xs,
    color: theme.gray_color_alpha(0.7)
  }
});

let default_format = 'D/M/YYYY';
export const TimeStamp = ({ value, only_time, only_day, only_week, only_date_time, only_relative, distance_options, style, date_format }) => {
  date_format = date_format || default_format;
  const date = new Date(value);
  const text =
    (only_time && format(date, 'HH:mm')) ||
    (only_day && getOnlyDay(date, date_format)) ||
    (only_week && getOnlyWeekDay(date, date_format)) ||
    (only_relative && distanceInWordsToNow(date, distance_options || { includeSeconds: true, addSuffix: true, locale: lang_list[lang.LANG_CODE] })) ||
    (only_date_time && format(date, 'D/M/YYYY HH:mm')) ||
    format(date, date_format);
  return (
    <Text title={format(date, 'D/M/YYYY HH:mm')} style={[styles.text, style]}>
      {text}
    </Text>
  );
};

function getOnlyWeekDay(date, date_format) {
  return isToday(date) ? format(date, 'HH:mm') : isYesterday(date) ? lang.YESTERDAY : isPastAmountOfDays(date) ? lang.DAYS[getDay(date)] : format(date, date_format);
}

function getOnlyDay(date, date_format) {
  return isToday(date) ? lang.TODAY : isYesterday(date) ? lang.YESTERDAY : format(date, date_format);
}

function isPastAmountOfDays(date, days = 7) {
  const now = Date.now();
  const start_date = subDays(now, days);
  return isWithinRange(date, start_date, now);
}



// WEBPACK FOOTER //
// ./src/components/core/timestamp.js